import { render, staticRenderFns } from "./BulkActionStatusField.vue?vue&type=template&id=2dfb6e94&lang=pug"
import script from "./BulkActionStatusField.vue?vue&type=script&lang=js"
export * from "./BulkActionStatusField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports